import React from "react";
import { Tooltip as AntTooltip } from "antd";
import PropTypes from "prop-types";

import "antd/es/tooltip/style/css";

import styles from "./tooltip.css";

export function Tooltip(props) {
  const {
    children,
    content,
    trigger = TOOLTIP_TRIGGER.HOVER,
    type = TOOLTIP_TYPES.MEDIUM,
    position = TOOLTIP_POSITION.TOP,
    onVisibleChange,
    visible = false,
    getContainer = () => document.body,
    destroyOnClose = true,
    className,
    alwaysVisible,
    mouseEnterDelay, // delay showing tooltip on mouse enter (in seconds default 0.1)
    mouseLeaveDelay // delay hiding tooltip on mouse leave (in seconds default 0.1)
  } = props;

  let tooltipProps = {};
  if (alwaysVisible) {
    tooltipProps.visible = true;
  }

  const getPosition = (position) => {
    const rtlPosition = {
      top: "top",
      right: "left",
      left: "right",
      bottom: "bottom",
      topLeft: "topRight",
      topRight: "topLeft",
      bottomLeft: "bottomRight",
      bottomRight: "bottomLeft",
      leftTop: "rightTop",
      leftBottom: "rightBottom",
      rightTop: "leftTop",
      rightBottom: "leftBottom"
    };
    return window.isRTL ? rtlPosition[position] : position;
  };

  return (
    <AntTooltip
      title={content}
      type={type}
      placement={getPosition(position)}
      overlayClassName={`${styles.tooltip} ${className}`}
      defaultVisible={visible}
      onVisibleChange={onVisibleChange}
      getPopupContainer={getContainer}
      destroyTooltipOnHide={destroyOnClose}
      mouseEnterDelay={mouseEnterDelay}
      mouseLeaveDelay={mouseLeaveDelay}
      trigger={trigger}
      {...tooltipProps}
    >
      {children}
    </AntTooltip>
  );
}

export const TOOLTIP_TYPES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

export const TOOLTIP_POSITION = {
  TOP: "top",
  LEFT: "left",
  RIGHT: "right",
  BOTTOM: "bottom",
  TOP_LEFT: "topLeft",
  TOP_RIGHT: "topRight",
  BOTTOM_LEFT: "bottomLeft",
  BOTTOM_RIGHT: "bottomRight",
  LEFT_TOP: "leftTop",
  LEFT_BOTTOM: "leftBottom",
  RIGHT_TOP: "rightTop",
  RIGHT_BOTTOM: "rightBottom"
};

export const TOOLTIP_TRIGGER = {
  HOVER: "hover",
  FOCUS: "focus",
  CLICK: "click"
};

Tooltip.propTypes = {
  children: PropTypes.any,
  content: PropTypes.any,
  type: PropTypes.string,
  position: PropTypes.string,
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  getContainer: PropTypes.func,
  destroyOnClose: PropTypes.bool,
  tooltipVisible: PropTypes.bool,
  className: PropTypes.string,
  alwaysVisible: PropTypes.bool,
  mouseEnterDelay: PropTypes.number,
  mouseLeaveDelay: PropTypes.number,
  trigger: PropTypes.string
};
